module.exports = __webpack_public_path__ + "img/price-start.699323ff.png";